export * from '@primeuix/themes/lara/dialog';
export { default } from '@primeuix/themes/lara/dialog';
